module.exports = __webpack_public_path__ + "images/if6_trend_down.svg?032ab12198d5c38ab67ba887b8ebd629";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/if6_trend_down.svg
// module id = 7T7U
// module chunks = 0